import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Root } from './Login.css';
import * as reducer from './Login.reducer';
import '../../index.css';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { roleInfo } from '../../common/common'
import Toast from '../Layout/components/Toast';

const ADMIN = "admin";
const DEPT = "dept_manager";
const TEAM = "team_leader";
const STAFF = "staff";
const BILL_ADMIN = "billing_manager";
class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            toHome: false,
            username: "",
            password: "",
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onKeyup = this.onKeyup.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Fragment>
                <Root className="c">
                    <AppBar position="absolute" color="default">
                        <Toolbar>
                            <div className="logo"></div>
                        </Toolbar>
                    </AppBar>
                    <div className="loginWapper h">
                        <div className="leftWapper v v-c">
                            <div className="avatars"></div>
                            <div className="title">Sign in</div>
                            <div className="textWapper">
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    id="username"
                                    label="Username"
                                    name="username"
                                    autoComplete="username"
                                    onChange={e => this.handleChange(e, 'username')}
                                    onKeyUp={this.onKeyup}
                                    autoFocus
                                />
                                <TextField
                                    className="t2"
                                    variant="outlined"
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="password"
                                    onChange={e => this.handleChange(e, 'password')}
                                    onKeyUp={this.onKeyup}
                                />
                                <Button
                                    fullWidth
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    onClick={this.handleLogin}
                                    onKeyUp={this.onKeyup}
                                >
                                    Sign In
                                </Button>
                            </div>
                            <div className="line"></div>
                            <div className="logoWapper h h-r">
                                <div className="logo2"></div>
                            </div>
                        </div>

                        <div className="rightWapper c">
                            <div className="loginImg"></div>
                        </div>
                    </div>
                </Root>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Fragment>
        );

    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    onKeyup(e) {
        if (e.keyCode === 13) {
            this.toLogin();
        }
    }
    handleLogin() {
        this.toLogin();
    }
    toLogin() {
        // this.setState(() => ({
        //     toHome: true
        // }));
        const username = this.state.username;
        const password = this.state.password;
        if (!username) {
            this.showToast("Please enter the account number", "error");
            return;
        }
        if (!password) {
            this.showToast("Please enter your password", "error");
            return;
        }
        let params = {
            username,
            password
        }
        const { doLogin, history } = this.props;
        doLogin(params, (isLogin, msg) => {
            if (isLogin) {
                const crtRole = this.getRole();
                console.log("crtRole", crtRole);
                localStorage.setItem('isReload', '1');
                //localStorage.setItem('pwd', this.state.password);
                localStorage.setItem('roleName', crtRole);
                if (crtRole === ADMIN) {
                    history.push({ pathname: '/main/department' });
                } else if (crtRole === DEPT) {
                    history.push({ pathname: '/main/deptTeam' });
                } else if (crtRole === TEAM) {
                    history.push({ pathname: '/main/leaderteam' });
                } else {
                    history.push({ pathname: '/main/user' });
                }
            } else {
                this.showToast("Incorrect username or password", "error");
            }
        });
    }

    // todo: refactor is needed since user may have more than one roles
    getRole() {
        let roleArr = roleInfo.identity.role;
        let isAdmin = false;
        let isDeptManager = false;
        let isTeamLeader = false;
        let isStaff = false;
        console.log(roleArr);
        for (const item of roleArr) {
            if (item === ADMIN) {
                isAdmin = true;
            } else if (item === DEPT) {
                isDeptManager = true;
            } else if (item === TEAM) {
                isTeamLeader = true;
            } else if (item === STAFF) {
                isStaff = true;
            }
        }
        if (isAdmin) {
            return ADMIN
        } else if (isDeptManager) {
            return DEPT
        } else if (isTeamLeader) {
            return TEAM
        } else if (isStaff) {
            return STAFF
        }
    }

}

// store映射
const mapStateToProps = (state) => {
    return {
    }
}
const mapDispathToProps = (dispath) => {
    return {
        doLogin: (param, callback) => {
            dispath(reducer.doLogin(param, callback));
        }
    }
}

export default connect(mapStateToProps, mapDispathToProps)(Login);